import { createStore } from "@xstate/store";

export const listCalendarStore = createStore({
  context: { month: new Date() },
  on: {
    "month.set": (_ctx, e: { month: Date }) => ({ month: e.month }),
    "month.sync": (_ctx, e: { date: Date }) => ({ month: e.date }),
  },
});
